// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.inactivity.InactivityConfiguration
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

export class InactivityConfigurationBase {
  /** Do NOT invoke directly, instead use strongly typed createInactivityConfigurationBase factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadi.InactivityConfiguration";
  }
  initFromJson(json, deserializeContext) {
    this.initInactivityConfiguration(json.userInactivityTimeoutMinutes != null ? json.userInactivityTimeoutMinutes : null, json.userInactivityWarningMinutes != null ? json.userInactivityWarningMinutes : null);
  }
  initInactivityConfiguration(userInactivityTimeoutMinutes, userInactivityWarningMinutes) {
    this._userInactivityTimeoutMinutes = userInactivityTimeoutMinutes;
    this._userInactivityWarningMinutes = userInactivityWarningMinutes;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    if (this._userInactivityTimeoutMinutes != null) {
      retVal["userInactivityTimeoutMinutes"] = this._userInactivityTimeoutMinutes;
    }
    retVal["userInactivityWarningMinutes"] = this._userInactivityWarningMinutes;
    return retVal;
  }
  get userInactivityTimeoutMinutes() {
    return this._userInactivityTimeoutMinutes;
  }
  set userInactivityTimeoutMinutes(value) {
    this._userInactivityTimeoutMinutes = value;
  }
  get userInactivityWarningMinutes() {
    return this._userInactivityWarningMinutes;
  }
  set userInactivityWarningMinutes(value) {
    this._userInactivityWarningMinutes = value;
  }
}
//# sourceMappingURL=InactivityConfigurationBase.js.map
